<!-- Small/Medium viewport -->
<ul class="d-flex d-lg-none list-group" [ngClass]="{ 'shake' : showgrip }">
  <li class="list-group-item d-flex justify-content-between align-items-center subheader pt-1 pb-1">
    <div class="col-12 d-block" *ngIf="document.documentStatus === 'Uploading' || (document.documentStatus === 'Processing' && document.progress > 0)">
      <ngb-progressbar type="primary" [value]="(document.uploadProgress + document.progress)" [striped]="document.documentStatus == 'Processing' || document.filetype?.toLocaleLowerCase() == '.xbrl'" [animated]="document.documentStatus == 'Processing' || document.filetype?.toLocaleLowerCase() == '.xbrl'"></ngb-progressbar>
    </div>
    <div class="col-12" *ngIf="document.documentStatus === 'Processing' && !document.progress">
      <ngb-progressbar type="processing" [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
    </div>
    <div class="col-3 col-md-2 text-truncate" *ngIf="document.documentStatus !== 'Uploading' && document.documentStatus !== 'Processing'">
      <i class="bi bi-exclamation-circle-fill text-danger me-2" *ngIf="document.documentStatus === 'Error' || (document.documentStatus !== 'Error' && document.error)"></i>
      <strong>{{ 'Request.Document.Document' | translate }} {{position+1}}</strong>
    </div>
    <div class="col-9 col-md-10" *ngIf="document.documentStatus !== 'Processing'">
      <span class="float-end">
        <div class="btn-group">
          <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
          </button>
          <ul class="dropdown-menu">
            <li *ngIf="itemsInRequest > 1 && sortingAllowed"><a class="dropdown-item pt-1 pb-1" (click)="EnableDocumentChangeOrder(position, document.id)">{{ 'Button.ChangeOrder' | translate }}</a></li>
            <li *ngIf="showDocument && document.documentStatus !== 'Error'"><a class="dropdown-item pt-1 pb-1" (click)="openPreview()" translate>Button.ViewDocument</a></li>
            <li><a class="dropdown-item pt-1 pb-1" (click)="DocumentDeleted(document.id)">{{ 'Button.Delete' | translate }}</a></li>
          </ul>
        </div>
      </span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate" [ngClass]="{ 'disabledDiv': document.documentStatus === 'Error'}">
      <span translate>Request.Document.Filename</span>
    </div>
    <div class="col-9 col-md-10 text-truncate" [ngClass]="{ 'disabledDiv': document.documentStatus === 'Error'}">
      <span>{{document.name}}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate" [ngClass]="{ 'disabledDiv': document.documentStatus === 'Error'}">
      <span translate>Request.Document.Type</span>
    </div>
    <div class="col-9 col-md-10 text-truncate" [ngClass]="{ 'disabledDiv': document.documentStatus === 'Error'}">
      <span>{{'Request.Document.'+document.documentType | translate }}</span>
    </div>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
    <div class="col-3 col-md-2 text-truncate" [ngClass]="{ 'disabledDiv': document.documentStatus === 'Error'}">
      <span translate>Request.Document.Size</span>
    </div>
    <div class="col-9 col-md-10 text-truncate" [ngClass]="{ 'disabledDiv': document.documentStatus === 'Error'}">
      <span>{{document.fileSize | byteSizePipe}}</span>
    </div>
  </li>
  <ng-container *ngIf="document.documentStatus === 'Error'">
    <li class="list-group-item d-flex justify-content-between align-items-center pt-1 pb-1">
      <div class="col-9 col-md-10 w-100 text-truncate">
          <div *ngIf="document.filetype === '.XBRL' && !document.error" class="alert alert-danger p-1 mb-0" role="alert">
            <span translate>Error.ValidationErrorXBRL</span>
          </div>
      </div>
    </li>
  </ng-container>
</ul>

<!-- Large viewport -->
<div class="row w-100 d-none d-lg-flex p-0 align-items-center">
  <ng-container *ngIf="document.documentStatus === 'Uploading' || (document.documentStatus === 'Processing' && document.progress > 0)">
    <div class="col-12 document-progressbar text-truncate">
      <ngb-progressbar type="primary" [value]="(document.uploadProgress + document.progress)" [striped]="true" [animated]="true"></ngb-progressbar>
    </div> 
  </ng-container>
  <ng-container *ngIf="document.documentStatus === 'Processing' && !document.progress">
    <div class="col-12 document-progressbar text-truncate">
      <ngb-progressbar type="processing" [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
    </div> 
  </ng-container>
  <ng-container *ngIf="document.documentStatus !== 'Uploading' && document.documentStatus !== 'Processing'">
    <div *ngIf="document.documentStatus === 'Error' || (document.documentStatus !== 'Error' && document.error)" class="col-1 firstcol">
      <i class="bi bi-exclamation-circle-fill text-danger"></i>
    </div>
    <div *ngIf="document.documentStatus !== 'Error' && !document.error && document.documentStatus !== 'Processing'" class="col-1 firstcol text-truncate">
      {{position+1}}
    </div>
    <div class="col-6 text-truncate">
      {{document.name}} 
    </div>
    <div class="col-1"></div>
    <div class="col-2 text-truncate" >{{'Request.Document.'+document.documentType | translate }}</div>
    <div class="col-1 text-truncate">{{document.fileSize | byteSizePipe}}</div>
    <div class="col-1">
      <span class="float-end">
        <div class="float-end ms-2" *ngIf="itemsInRequest > 1 && sortingAllowed"><i class="bi bi-grip-vertical bi-large cursor-change-order"></i></div>
        <div class="btn-group">
          <button type="button" class="btn bg-transparent border-0 p-0" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots bi-large"></i>
          </button>
          <ul class="dropdown-menu">
            <li *ngIf="showDocument"><a class="dropdown-item pt-1 pb-1" (click)="openPreview()" translate>Button.ViewDocument</a></li>
            <li *ngIf="showEditDocument"><a class="dropdown-item pt-1 pb-1" (click)="editDocument()" translate>Button.EditDocument</a></li>
            <li><a class="dropdown-item pt-1 pb-1" (click)="DocumentDeleted(document.id)" translate>Button.Delete</a></li>
          </ul>
        </div>
      </span>
    </div>
  </ng-container>
</div>
<div *ngIf="document.documentStatus === 'Error'" class="d-none d-lg-flex row w-100 d-flex p-0 align-items-center">
  <div class="col-1">&nbsp;</div>
  <div class="col-6 error text-truncate ms-0">
    <div *ngIf="document.filetype === '.XBRL' && !document.error" class="alert alert-danger p-1 mb-0" role="alert">
      <span translate>Error.ValidationErrorXBRL</span>
    </div>
  </div>
</div>